module.exports = __webpack_public_path__ + "img/4.f9c87171.png";